import styled from 'styled-components';

const H2 = styled.h2.attrs({
  className: `
    text-2xl
    font-semibold
    text-center
    text-gray-600

    dark:text-gray-300
  `,
})``;

export default H2;
